/**
 * Static map: account API error `code` → its i18n key. Every value is a source
 * LITERAL so the key set is greppable and verifiable against
 * locales/en/common.json — no template-interpolated `t()` keys (see the
 * no-dynamic-i18n-keys convention). Add a new code here AND in common.json's
 * `errors` block together; unknown codes fall back to the caller's handling.
 */
export const ERROR_MESSAGE_KEYS = {
  unauthorized: "errors.unauthorized",
  missing_name: "errors.missing_name",
  config_error: "errors.config_error",
  db_error: "errors.db_error",
  not_owner: "errors.not_owner",
  not_found: "errors.not_found",
  no_update_fields: "errors.no_update_fields",
  not_member: "errors.not_member",
  org_not_active: "errors.org_not_active",
  missing_org_id: "errors.missing_org_id",
  missing_user_identifier: "errors.missing_user_identifier",
  user_not_found: "errors.user_not_found",
  already_member: "errors.already_member",
  cannot_remove_owner: "errors.cannot_remove_owner",
  membership_not_found: "errors.membership_not_found",
  missing_params: "errors.missing_params",
  invalid_owner_param: "errors.invalid_owner_param",
  cannot_remove_self_owner: "errors.cannot_remove_self_owner",
  cognito_error: "errors.cognito_error",
};

export const UNKNOWN_ERROR_KEY = "errors.unknown";
